import React from 'react';  
import './index.css';
import { WingBlank, WhiteSpace ,Icon} from 'antd-mobile'; 
import history from 'common/history';
import UserIcon from './img/icon_user.png';
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'courseLiveInfoStore';
class MemberList extends React.Component{
 
  render(){
    return (
        <div className="member-list">
          <div className="icon-img">
             <img alt='' src={UserIcon} />
          </div> 
          <div className="member-name">{this.props.name}</div>
        </div> 
      )
  }
}
 class InfoMember extends React.Component{
   constructor(props){
    super(props)
    this.state={
      arr:[]
    }
  }
 componentDidMount(){
  const {memberlist}= this.props;
  if( memberlist){
    let list = memberlist.toJS()
      this.setState({
        arr:list
      })
   }
 
 }
  componentWillReceiveProps(nextProps) { 
    const {memberlist}= this.props;
    
    
    if (memberlist && (nextProps.memberlist.toJS() !== this.props.memberlist.toJS())) {
           let list = nextProps.memberlist.toJS()
            this.setState({
              arr:list
            })
  
    }
      
  }
  render(){
    const {arr} =this.state;
    return (
      <div className="tab-member">
        <WhiteSpace/>
        <WingBlank>
        <div className="member-box"> 
        {
                arr&&arr.length>0?
                arr.map((item,index)=>{
                 return(
                   <MemberList key={index} name={item.realName}/> 
                   ) 
                }):
                <p style={{textAlign:'center'}}>暂无成员</p>
              }
          
        </div>
         
        </WingBlank>
      </div>
      )
  }
}
 
 
const mapState = (state) => ({ 
 
  memberlist:state.getIn(['courseliveinfo','memberlist']),
 
 })
 

const mapDispatch = (dispatch) => ({
 
})
export default connect(mapState, mapDispatch)(InfoMember);

 

 